<template>
  <div>
    <in-progress v-if="pageOnWorking" />
    <div v-if="product && !pageOnWorking">
      <div class="uk-text-center">
        <h4>Reporte de la cadena de Frío</h4>
        <p v-if="product.selectedProducts.length > 0">
          <span>{{ product.companyName }}</span> - <span>{{ product.selectedProducts.map(x => x.product + " " + x.subProduct ?? '').join(", ") }}</span>
        </p>
      </div>
      <div uk-grid>
        <cold-chain-table
          v-if="false"
          class="uk-width-1-1"
        />
        <transport-storage-temperatures
          v-if="false"
          class="uk-width-1-1"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TransportStorageTemperatures from '../ColdChainComponents/TransportStorageTemperatures.vue'
import ColdChainTable from '../ColdChainComponents/ColdChainTable.vue'
import { mapState } from 'vuex'
import InProgress from '../../views/InProgress.vue'
export default {
  components: {
    ColdChainTable,
    TransportStorageTemperatures,
    InProgress
  },
  data () {
    return {
      pageOnWorking: true
    }
  },
  computed: {
    ...mapState([
      'product'
    ])
  },
  mounted () {
    if (!this.product) {
      this.$router.push({ name: 'Home' })
    }
    this.$windowPlugin.scrollToTop()
  }
}
</script>
